import { RootState } from '../../../../rootReducer';

export const shippingOrdersSelector = (state: RootState) => state.documentModuleReducer.ShippingOrdersReducer;
